import { useState, useEffect } from 'react';
import { calculatePrice, formatPrice, getPriceTier, DEFAULT_PRICING_CONFIG } from '../utils/pricing';

export default function usePricing(formData) {
  const [config, setConfig] = useState(DEFAULT_PRICING_CONFIG); // Start with defaults
  const [loading, setLoading] = useState(true);
  const [enabled, setEnabled] = useState(true); // Default to enabled

  // Fetch pricing config on mount
  useEffect(() => {
    async function fetchConfig() {
      try {
        const res = await fetch('/api/pricing');
        if (res.ok) {
          const data = await res.json();
          setEnabled(data.enabled);
          if (data.config) {
            setConfig(data.config);
          }
        }
      } catch (err) {
        // On error, keep using defaults with pricing enabled
        console.error('Failed to fetch pricing config, using defaults:', err);
      } finally {
        setLoading(false);
      }
    }
    fetchConfig();
  }, []);

  // Calculate price immediately using current config (defaults or fetched)
  const priceData = enabled ? calculatePrice(formData, config) : null;

  return {
    loading,
    enabled,
    priceData,
    formattedPrice: priceData ? formatPrice(priceData.total, config?.currency) : null,
    tier: priceData ? getPriceTier(priceData.total) : null,
    showBreakdown: config?.showBreakdown || false
  };
}
